import * as palette from "@govlaunch/palette";
import { IGetGovernmentQuery } from "../../lib/queries/__generated__/GetGovernmentQuery.generated";
import Container from "../layout/Container";

interface IAwardsProps {
  government: NonNullable<IGetGovernmentQuery["government"]>;
}

export default function Awards({ government }: IAwardsProps) {
  return (
    <Container>
      <div
        css={{
          background: "#fff",
          borderRadius: 4,
          border: `1px solid ${palette.lightestGray}`
        }}
      >
        <div
          css={{
            padding: 16,
            display: "flex",
            borderBottom: `1px solid ${palette.lightestGray}`
          }}
        >
          <span
            css={{
              fontSize: 12,
              fontWeight: 500,
              color: palette.sealBlue,
              textTransform: "uppercase"
            }}
          >
            🏅 Awards
          </span>
        </div>

        <div
          css={{
            padding: 16
          }}
        >
          <div
            css={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              flexWrap: "wrap",
              marginTop: -8
            }}
          >
            {government.awards.map((award) => {
              return (
                <span
                  key={award._id}
                  css={{
                    padding: "5px 10px",
                    marginTop: 8,
                    marginRight: 8,
                    backgroundColor: palette.mediumBlue,
                    borderRadius: 13.5,
                    fontSize: 14,
                    color: palette.text
                  }}
                >
                  {award.name}
                </span>
              );
            })}
          </div>
        </div>
      </div>
    </Container>
  );
}
